export function Right({ children, ...props }) {

    return (
        <div {...props}>
            <div className="right">{children}</div>
        </div>
    );
}
